import { Col, Form, Modal, Row } from 'react-bootstrap';
import { Button as MyButton } from "./Button";
import { AbandonedVehicleStatus, VehicleSituation,  } from "../api/Network";
import { DisplayVehicleType, showDisplayVehicleType } from "../loaders/abandonedVehicleCompressed";
import React from "react";
import { showPercent } from "../common/Percent";
import { getStatusIcon, getVehicleSituationIcon, getVehicleTypeIcon, IconResult } from "./AbandonedVehicleStatusIconNew";
import { showAbandonedVehicleStatus, showVehicleSituation } from "../api/EnumUtils";
import { FilterButton } from "./CompareFilterModal";
import { showVehicleType } from "./Annotation/VehicleType";

export interface AnnotationFilter {
    typeFilters:      Array<DisplayVehicleType | null>;
    situationFilters: Array<VehicleSituation | null>;
    statusFilters:    Array<AbandonedVehicleStatus>;
    confThr:          number;
    similarityThr:    number;
}

interface AnnotationFilterProps {
    filters:    AnnotationFilter;
    setFilters: ( filters: AnnotationFilter ) => void;
}

interface StatusFilterModalProps extends AnnotationFilterProps {
    show: boolean;
    onHide: () => void;
}

// const vehicleSits = [
//     VehicleSituation.Street,                        
//     VehicleSituation.Shoulder,              
//     VehicleSituation.Sidewalk,              
//     VehicleSituation.Field,             
//     VehicleSituation.Alleyway,              
//     VehicleSituation.Driveway,              
//     VehicleSituation.ParkingLot,                
//     VehicleSituation.Junkyard,              
//     VehicleSituation.Worksite,              
//     VehicleSituation.Industrial,               
// ];

const vehicleTypes = [
    null,
    DisplayVehicleType.Car,
    DisplayVehicleType.Pickup,
    DisplayVehicleType.Suv
];

const abandonedVehicleStatuses = [
    AbandonedVehicleStatus.ReviewedVerified,
    AbandonedVehicleStatus.Candidate,
    AbandonedVehicleStatus.ReviewedUnsure,
    // AbandonedVehicleStatus.ReviewedRejected,
    AbandonedVehicleStatus.ReviewedRejectedIdentity,
    AbandonedVehicleStatus.ReviewedRejectedMoved,
    AbandonedVehicleStatus.ReviewedRejectedNotAVehicle,
    AbandonedVehicleStatus.ReviewedRejectedDeparted,
    AbandonedVehicleStatus.ReviewedRejectedArrived,
];

export function AnnotationFilterBody( { filters, setFilters }: AnnotationFilterProps ) {
    const handleSliderChange = ( field: keyof AnnotationFilter, value: number ) => {
        setFilters( {
            ...filters,
            [field]: value
        } );
    }

    return <React.Fragment>
        {/* <Row className="g-2 mb-2"> */}
            {/* <VehicleSitButton cols={1} sit={null} filter={filter} setFilters={setFilters} /> */}
            {/* {vehicleSits.map( si =>
                <FilterButton<VehicleSituation | null>
                    key={si}
                    value={si}
                    label={showVehicleSituation( si )}
                    filter={filters.situationFilters}
                    onChange={ x => setFilters( ({ ...filters, situationFilters: x }) ) } 
                    getIcon={getVehicleSituationIcon} 
                    cols={4} />)}
        </Row> */}
        <Row className="g-2 mb-2">
            {abandonedVehicleStatuses.map( st => 
                <FilterButton<AbandonedVehicleStatus>
                    key={st}
                    value={st}
                    label={showAbandonedVehicleStatus( st )}
                    filter={filters.statusFilters}
                    onChange={ x => setFilters( ({ ...filters, statusFilters: x }) ) } 
                    getIcon={getStatusIcon}
                    cols={6} />)}
        </Row>
        <Row>
            <Col>Vehicle Types</Col>
        </Row>
        <Row className="g-2 mb-2">            
            {vehicleTypes.map( type => 
                <FilterButton<DisplayVehicleType | null>
                    key={type}
                    value={type}
                    label={showDisplayVehicleType( type )}
                    filter={filters.typeFilters}
                    onChange={ x => setFilters( ({ ...filters, typeFilters: x }) ) } 
                    getIcon={getVehicleTypeIcon} 
                    cols={3} />)}
        </Row>
        <Row className="p-1 mb">
            <Col md={6}>
                <div className=" mb-2">
                    <Form.Label>Confidence &gt; {showPercent( filters.confThr )}</Form.Label>
                    <Form.Range
                        min={0}
                        max={1.0}
                        step={0.05}
                        value={filters.confThr}
                        onChange={( e ) => handleSliderChange( 'confThr', parseFloat( e.target.value ) )}
                    />
                </div>
            </Col>
            <Col md={6}>
                <div className="mb-2">
                    <Form.Label>Similarity &gt; {showPercent( filters.similarityThr )}</Form.Label>
                    <Form.Range
                        min={0}
                        max={1.0}
                        step={0.05}
                        value={filters.similarityThr}
                        onChange={( e ) => handleSliderChange( 'similarityThr', parseFloat( e.target.value ) )}
                    />
                </div>
            </Col>
        </Row>
    </React.Fragment>;
}

export function AnnotationFilterModal( { show, onHide, filters: filter, setFilters }: StatusFilterModalProps ) {
    const handleClose = () => {
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AnnotationFilterBody filters={filter} setFilters={setFilters} />
                <div className="d-flex gap-2">
                    <MyButton className="w-100" onClick={onHide}>
                        Close
                    </MyButton>
                </div>
            </Modal.Body>
        </Modal>
    );
}